<template>
    <div class="box">
        <div class="v_header flexCenter" ref="getheight">
            <span class="headline">数据明细</span>
            <el-button class="input_button" size="mini" @click="getExport">导出</el-button>
        </div>
        <div class="u_input flexCenter" ref="getheight1">
            <span class="test">医院名称</span>
            <el-input @change="getHospital_name" placeholder="请输入医院名称" clearable v-model="page.search_hospital_name" />
            <span class="test">姓名</span>
            <el-input @change="getUser_name" placeholder="请输入姓名" v-model="page.search_user_name" clearable size="mini" />
            <span class="test">省份</span>
            <el-select v-model="page.province_id" @change="getProvince_id" placeholder="请选择省" clearable size="mini">
                <el-option v-for="item in area" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <span class="test">市级</span>
            <el-select v-model="page.city_id" @change="getCity_id" placeholder="请选择市" clearable size="mini">
                <el-option v-for="item in cityarr" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <!-- <el-button class="input_button search" size="mini" @click="getSearch">查询</el-button> -->
        </div>
        <el-table :data="message" :max-height="height + 'px'">
            <el-table-column fixed label="提交时间" width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    {{ scope.row.created_on | formatOrdertime }}
                </template>
            </el-table-column>
            <el-table-column label="姓名/手机号" :render-header="renderPrice" width="150">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.name + scope.row.phone_number" placement="bottom">
                        <div>
                            {{ scope.row.name }}
                            <div>{{ scope.row.phone_number }}</div>
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="所属医院" min-width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.hospital_name" placement="bottom">
                        <span class="v_tips">{{ scope.row.hospital_name }} </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="医院地址" width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.province_name + scope.row.city_name + scope.row.district_name + scope.row.hospital_position_detail
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.province_name }} {{ scope.row.city_name }} {{ scope.row.district_name }}
                            {{ scope.row.hospital_position_detail }}</span
                        >
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="微信定位" width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.wechat_province_name +
                            scope.row.wechat_city_name +
                            scope.row.wechat_district_name +
                            scope.row.wechat_position_detail
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.wechat_province_name }} {{ scope.row.wechat_city_name }} {{ scope.row.wechat_district_name }}
                            {{ scope.row.wechat_position_detail }}
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="奖励码/产品" width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.red_envelope_label + scope.row.product_info.product_name + scope.row.product_info.product_number
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.red_envelope_label }} {{ scope.row.product_info.product_name }}&{{
                                scope.row.product_info.product_number
                            }}</span
                        >
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="溯源码" width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="bottom">
                        <span class="v_tips">{{ scope.row.label }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="奖励金额" width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    <span>￥{{ scope.row.red_envelope_amount }}</span>
                </template>
            </el-table-column>
            
            <el-table-column prop="client_user_info.company _name" label="状态">
                <template slot-scope="scope">
                    <span class="v_tips">{{ scope.row.status | data_detail_status_list }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="client_user_info.user_email" label="审核人">
                <template slot-scope="scope">
                    <span class="v_tips">{{ scope.row.user_email  }}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="备注" max-width="150" fixed="right">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.remarks" placement="bottom">
                        <span class="v_tips" style="-webkit-line-clamp: 3">{{ scope.row.remarks }}</span>
                    </el-tooltip>
                    <i class="el-icon-edit" style="cursor: pointer" @click="getRemarks(scope)"></i>
                </template>
            </el-table-column>
            
            <el-table-column label="宠物种类" width="150" >
                <template slot-scope="scope">
                    <span>{{ scope.row.pet_species }}</span>
                </template>
            </el-table-column>
            <el-table-column label="宠物年龄" width="150" >
                <template slot-scope="scope">
                    <span>{{ scope.row.pet_age }}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="职务" width="150" >
                <template slot-scope="scope">
                    <span>{{ scope.row.position }}</span>
                </template>
            </el-table-column>
            <el-table-column label="使用感受" width="150" >
                <template slot-scope="scope">
                    <span>{{ scope.row.vaccine_usage_experience }}</span>
                </template>
            </el-table-column>
            <el-table-column label="宠物医院课程" width="150" >
                <template slot-scope="scope">
                    <span>{{ scope.row.pet_hospital_course.length!=0 ? scope.row.pet_hospital_course.join(',') :'' }}</span>
                </template>
            </el-table-column>
            <el-table-column label=" 宠物渠道" width="150" >
                <template slot-scope="scope">
                    <span>{{ scope.row.pet_channel.length!=0 ? scope.row.pet_channel.join(','):'' }}</span>
                </template>
            </el-table-column>
            <el-table-column label=" 建议" width="150" >
                <template slot-scope="scope">
                    <span>{{ scope.row.recommendation }}</span>
                </template>
            </el-table-column>
            
        </el-table>
        <el-dialog title="备注信息" :visible.sync="resetDialogVisible" width="648px" top="15vh" class="v_dol">
            <el-input
                class="textarea"
                v-model="remarks.remarks"
                :autosize="{ minRows: 4, maxRows: 8 }"
                type="textarea"
                clearable
                placeholder="输入备注"
            ></el-input>
            <div class="dialog-footer">
                <!-- <el-button size="mini" @click="resetDialogFalse">取 消</el-button> -->
                <el-button class="v_buttons" size="mini" @click="resetDialogTrue">保 存</el-button>
            </div>
        </el-dialog>
        
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title" v-if="msg">{{ msg }}</div>
            </div>
        </div>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
export default {
    name: 'detail',
    data() {
        return {
            page: {
                num: 10,
                page: 1,
                total: 0,
                search_hospital_name: '',
                search_user_name: '',
                province_id: '',
                city_id: ''
            },
            index: -1,
            remarks: {}, //备注信息
            resetDialogVisible: false,
            message: [],
            area: [], //省
            cityarr: [], //市
            pages: 0,
            height: '',
            notificationns: false,
            msg: ''
        };
    },

    mounted() {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight.offsetHeight - this.$refs.getheight1.offsetHeight - 85 - 24 - 16 - 40;
        let area = localStorage.getItem('area');
        this.area = JSON.parse(area);
        this.getMessage(); //获取列表
    },
    methods: {
      
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num,
                search_hospital_name: that.page.search_hospital_name,
                search_user_name: that.page.search_user_name,
                province_id: that.page.province_id,
                city_id: that.page.city_id
            };
            that.$get('/backapi/data_detail', obj).then(function (res) {
                console.log(res);
                if (res.count) {
                    that.page.total = res.count;
                    that.message = res.data;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        //
        getRemarks(e) {
            this.remarks = JSON.parse(JSON.stringify(e.row));
            this.index = e.$index;
            this.resetDialogVisible = true;
        },
        resetDialogFalse() {
            this.resetDialogVisible = false;
            this.inde = -1;
            this.remarks = {};
        },
        resetDialogTrue() {
            let that = this;
            let obj = {
                id: that.remarks.id,
                remarks: that.remarks.remarks
            };
            that.$put('/backapi/data_detail', obj).then(function (res) {
                that.message[that.index].remarks = that.remarks.remarks;
                // that.$message({
                //     message: '保存成功',
                //     type: 'success'
                // });
                that.msg = '保存成功';
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                that.resetDialogFalse();
            });
        },
        // 搜索医院名字
        getHospital_name(e) {
            this.page.search_hospital_name = e;
            this.page.num = 10;
            this.page.page = 1;
            this.getMessage();
        },
        // 搜索用户名字
        getUser_name(e) {
            this.page.search_user_name = e;
            this.page.num = 10;
            this.page.page = 1;
            // this.page.search_user_name = e;
            this.getMessage();
        },
        // 获取省
        getProvince_id(e) {
            let that = this;
            if (e == '') {
                that.cityarr = [];
                that.page.city_id = '';
                that.getMessage();
            } else {
                that.page.province_id = e;
                that.$get('/backapi/area', { province_id: e }).then(function (res) {
                    that.cityarr = res.data;
                    that.page.city_id = '';
                    that.getMessage();
                });
            }
        },
        getCity_id(e) {
            this.page.city_id = e;
            this.getMessage();
        },
        // 查询
        getSearch() {
            this.getMessage();
        },
        // 导出
        getExport() {
            let that = this;
            if (that.page.total == 0) {
                that.$message({
                    message: '暂无数据导出',
                    type: 'warning'
                });
                return;
            }
            let obj = {
                page: 1,
                num: that.page.total,
                is_download: true
            };
            let message = [];
            that.$get('/backapi/data_detail', obj)
                .then(function (res) {
                    // message = res.data;
                    // if (message.length != 0 && message) {
                    //     const fdArray = [];
                    //     message.forEach(function (item, index) {
                    //         var obj = {
                    //             奖励发放时间: that.$formatOrdertime(item.created_on),
                    //             姓名手机号: item.name + item.phone_number,
                    //             所属医院: item.hospital_name, //
                    //             医院地址: item.province_name + item.city_name + item.district_name + item.hospital_position_detail,
                    //             微信定位:
                    //                 item.wechat_province_name +
                    //                 item.wechat_city_name +
                    //                 item.wechat_district_name +
                    //                 item.wechat_position_detail,
                    //             奖励码产品: item.red_envelope_label + item.product_info.product_name + item.product_info.product_number,
                    //             溯源码: item.label,
                    //             奖励金额: item.red_envelope_amount,
                    //             状态: that.$data_detail_status_list(item.status),
                    //             备注: item.remarks
                    //         };
                    //         fdArray.push(obj);
                    //     });

                    //     var wb = XLSX.utils.book_new();
                    //     let sheet = XLSX.utils.json_to_sheet(fdArray);
                    //     sheet['!cols'] = [
                    //         { wch: 20 },
                    //         { wch: 20 },
                    //         { wch: 30 },
                    //         { wch: 40 },
                    //         { wch: 40 },
                    //         { wch: 40 },
                    //         { wch: 40 },
                    //         { wch: 20 },
                    //         { wch: 10 },
                    //         { wch: 40 }
                    //     ];
                    //     XLSX.utils.book_append_sheet(wb, sheet, 'sheet', { raw: true });
                    //     XLSX.writeFile(wb, '数据明细 - 数据列表' + '.xlsx');
                    //     that.getExport();
                    // } else {
                    //     that.$message({
                    //         message: '暂无数据导出',
                    //         type: 'warning'
                    //     });
                    //     that.pages = 0;
                    // }
                    if (res.code == 200) {
                        that.msg = '数据导出成功'
                         that.notificationns = true
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    } else {
                        (that.msg = '导出失败'), (that.notificationns = true);
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    }
                })
                .catch((reject) => {
                    (that.msg = '导出失败'), (that.notificationns = true);
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                });
        }
    }
};
</script>

<style scoped lang="scss">
/deep/.el-textarea__inner {
    height: 193px !important;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;

    color: #697077;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
}
.dialog-footer {
    margin-top: 16px;
}
.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 129px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

/deep/ .v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
/deep/.el-input {
    width: 179px;
    margin-right: 16px;
}
/deep/.u_input .el-input__inner {
    width: 179px;
    height: 35px;
    background: #ffffff;
    border: 1px solid #16307c;
    border-radius: 4px;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;

    letter-spacing: 0.5px;

    color: #ababab;
    padding: 0 12px;
}
.test {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0.5px;
    color: #ababab;
    margin-right: 8px;
}

/deep/.el-table .el-table__cell {
    border: none;
}
.u_input {
    justify-content: flex-end;
    margin-bottom: 16px;
}

.search {
    background: #91d9f2 !important;
}
.v_header {
    justify-content: space-between;
    margin-bottom: 24px;
}
/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}
</style>
